<router-outlet/>

@if(showFooter) {
  <div style="background:#080808;border-top:1px solid rgba(255,255,255,0.06);padding:20px;display:flex;flex-direction:column;align-items:center;gap:16px;">

    @if(showBackHome) {
      <div style="display:flex;gap:10px;">
        <button class="btn-back" style="margin-top:0;" (click)="goBack()">← Back</button>
        <button class="btn-back" style="margin-top:0;" (click)="booth.reset()">⌂ Home</button>
      </div>
    }

    <div
      (click)="booth.handleAdminTap()"
      style="font-size:11px;color:rgba(255,255,255,0.2);letter-spacing:2px;cursor:pointer;user-select:none;padding:6px 14px;">
      Session: {{booth.sessionId()}}
    </div>
  </div>
}

<app-admin-modal/>

@if(showSessionInvalidatedOverlay) {
  <div style="position:fixed;inset:0;background:rgba(0,0,0,0.92);display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:9999;font-family:'Barlow Condensed',sans-serif;color:#fff;text-align:center;padding:32px;">
    <div style="font-size:28px;font-weight:800;color:#EE6C24;letter-spacing:2px;margin-bottom:12px;">This booth was reconfigured</div>
    <div style="font-size:18px;color:rgba(255,255,255,0.6);margin-bottom:24px;">Please scan the new QR code on the TV screen.</div>
    <button (click)="rescan()" style="background:#EE6C24;color:#fff;border:none;padding:14px 32px;border-radius:8px;font-size:16px;font-weight:700;letter-spacing:1px;cursor:pointer;">
      Got it
    </button>
  </div>
}
